import React from "react";

// The css styling for this component is in the ../styles/TextAreaType1.css file
import "./Contact.css";
import Connect from "../Connect/Connect";


// By extending the React.Component class, TextArea inherits functionality from it
class Contact extends React.Component 
{

    constructor(props)
    {

    	/* We MUST call the parent class contructor and send it the props object */
    	super(props);

	    // Setting the initial state of the TextArea component
	    this.state = 
	    {
	        contents: this.props.value
	    };


    } // End of constructor()
 

	

    
    // The render method returns the JSX that should be rendered
	render() 
	{

	    return (
			<div className="container">
	    	<div className="row">  
			<div className="col-md-8">	
		    	
		    	<h1 className="text-center"> Contact Charles </h1>	

				<form method="POST" action="/contact_form" >
                    <label class = "label" for="name">Name</label>
                    <br/>
                    <input type="text" class = "contact_input" id="name" name="name" placeholder="Your Name"/>
                    <br/>
                    <label class = "label" for="lname">E-mail</label>
                    <br/>
                    <input type="text" id="email" class = "contact_input" name="email" placeholder="Your E-mail Address"/>
                    <br/>
                    <label class = "label" for="message">Message</label>
                    <br/>
                    <textarea id="message" name="message" rows="8" class = "contact_input message_box" placeholder="Your Message to Charles"></textarea>
                    <br/>
                    <input type="submit" class = "submit" value="Submit"/>
					
                </form>

				</div>

				<div className="col-md-3">

<div className="row">
	<div className="col-md-12 sam">
	<Connect/>
	</div>
</div>

				</div>

				</div>
				</div>
				

					

	    	

	    )
	}

}; // End of class TextArea 

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js